import * as yup from 'yup';
var Validation = /** @class */ (function () {
    function Validation() {
        Object.defineProperty(this, "schema", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: yup.object({
                name: yup.string().required('Name is required'),
                percentOwnership: yup.number().min(0).max(100).required('Percent ownership is required').nullable(),
                ownerSince: yup.date().required('Owner since is required').typeError("Invalid Date!").nullable(),
                role: yup.string().required('Role is required'),
                currentAddressStreet: yup.string().required('Current address street is required'),
                currentAddressCity: yup.string().required('Current address city is required'),
                currentAddressCountry: yup.string().required('Current address country is required'),
                currentAddressPostcode: yup.string().required('Current address postcode is required'),
                previousAddressStreet: yup.string().required('Previous address street is required'),
                previousAddressCity: yup.string().required('Previous address city is required'),
                previousAddressCountry: yup.string().required('Previous address country is required'),
                previousAddressPostCode: yup.string().required('Previous address postcode is required'),
                socialSecurityNr: yup.string().required('Social security nr'),
                mobilePhoneNr: yup.string().required('Mobile phone is required'),
                dateOfBirth: yup.date().required('Date of birth is required').typeError("Invalid Date!").nullable(),
                personalEmail: yup.string().email('Enter a valid email').required('Personal email is required'),
                driverLicense: yup.string().required('Driver license is required'),
                passport: yup.string().required('Passport is required'),
                nationality: yup.string().required('Nationality is required'),
                passportCountryOfIssue: yup.string().required('Passport Country of Issue is required'),
                isAuthorizedSignatory: yup.boolean().required('Authorized Signatory is required')
            })
        });
        Object.defineProperty(this, "initialTouch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                name: true,
                percentOwnership: true,
                ownerSince: true,
                role: true,
                currentAddressCity: true,
                currentAddressCountry: true,
                currentAddressPostcode: true,
                currentAddressStreet: true,
                previousAddressCity: true,
                previousAddressCountry: true,
                previousAddressPostCode: true,
                previousAddressStreet: true,
                socialSecurityNr: true,
                mobilePhoneNr: true,
                dateOfBirth: true,
                personalEmail: true,
                driverLicense: true,
                passport: true,
                nationality: true,
                passportCountryOfIssue: true,
            }
        });
    }
    return Validation;
}());
export { Validation };
